<template>
  <v-card 
  v-if="viewMode === 'grid'"
  outlined :class="['mrow pa-4 elevation-0', {'disabled': disabled}, {'active-colored-mrow color1--text': currentSelection}, {'backgroundCard': active}]" :v-ripple="!disabled" style="height: 100%;">

    <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          small
          color="grey"
          v-on="on"
        >
          <v-icon small>mdi-android-debug-bridge</v-icon>
        </v-btn>
      </template>
      <v-card outlined class="elevation-0">
        <v-layout class="backgroundCard pa-2 caption">
          JSON
        </v-layout>
        <div class="c-hr"></div>
        <div class="pa-3">
          <span class="caption">
            {{ item }}
            <json-viewer :item="item"></json-viewer>
          </span>
        </div>
      </v-card>
    </v-menu>

    <v-layout align-start>
      <v-avatar color="background">
        <img class="c-align-self-start" src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="76px">
      </v-avatar>
      
      <div class="ml-3">
        <text-highlight style="white-space: initial;" class="text-uppercase" :queries="nameKeywords" highlightClass="highlight-class" highlightStyle="">{{ item.name }}</text-highlight>
        <div class="caption textSecondary--text">
          SKU: {{ item.sku }}
        </div>
        <div class="textSecondary--text caption mt-4">

          <c-ms-ii
          :metric_definition="item" 
          :realValue="item.total_stock"
          :key="item.id"
          alwaysScale
          labelMode
          ></c-ms-ii>

        </div>

        <slot name="extra">
          <!-- very useful for example in productions when selecting a definition to see if it can be produced -->
        </slot>
      </div>

    </v-layout>
  </v-card>
  <div
  v-else-if="viewMode === 'small'"
  :class="['mrow pa-4', {'disabled': disabled}, {'backgroundHover': active}, {'active-colored- color1--text': currentSelection}]" :v-ripple="!disabled">

    <v-layout align-center>
      <img class="c-align-self-start" src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="66px">
      <v-flex class="ml-1">
        <text-highlight style="white-space: initial;" :queries="nameKeywords" highlightClass="highlight-class" highlightStyle="">{{ item.name }}</text-highlight>
        <div class="caption textSecondary--text mb-2">
          SKU: {{ item.sku }}
        </div>
        <c-ms-ii
        :metric_definition="item" 
        :realValue="item.total_stock"
        :key="item.id"
        alwaysScale
        labelMode
        ></c-ms-ii>
      </v-flex>
    </v-layout>
  </div>
  <tr v-else-if="viewMode === 'table'"
  :class="[{'active': active}, {'disabled': disabled}, {'color1--text': currentSelection}]">
    <td>
      <text-highlight style="white-space: initial;" :queries="skuKeywords" highlightClass="highlight-class" highlightStyle="">{{ item.sku }}</text-highlight>
    </td>
    <td>
      <v-layout align-center>

        <!--
        <v-avatar
        color="text"
        size="22px"
        class="font-weight-light white--text mr-2">
          {{ (item.name || '?').charAt(0) }}
        </v-avatar>
        -->

        <text-highlight style="white-space: initial;" :queries="nameKeywords" highlightClass="highlight-class" highlightStyle="">{{ item.name }}</text-highlight>
      </v-layout>
    </td>
    <td>
      <template v-if="item.total_stock !== 0">

        <c-ms-ii
        :metric_definition="item" 
        :realValue="item.total_stock"
        :key="item.id"
        alwaysScale
        labelMode
        ></c-ms-ii>

        <v-chip outlined v-if="item.items.length > 1">
          <v-icon small color="color1">mdi-comment-eye-outline</v-icon>
          <span class="caption color1--text">
            {{ item.items.length }}
          </span>
        </v-chip>
      </template>
      <div v-else class="grey--text caption">
        Out of stock!
      </div>
    </td>
    <td>
      <text-highlight class="text-truncate" :queries="searchFilters.id + ''" highlightClass="color1--text" highlightStyle="background: none;">{{ item.id }}</text-highlight>
    </td>
    <td>
      Coming soon
    </td>
  </tr>
</template>

<script>
import TextHighlight from 'vue-text-highlight'
import JsonViewer from '@/components/toolbox/json-viewer/Main'

export default {
  props: ['item', 'viewMode', 'searchFilters', 'disabled', 'active', 'currentSelection'],
  components: {
    JsonViewer,
    TextHighlight
  },
  computed: {
    definition () {
      return this.item
    },
    nameKeywords () {
      return (this.searchFilters.name || '').trim().split(/\s+/)
    },
    skuKeywords () {
      return (this.searchFilters.sku || '').trim().split(/\s+/)
    }
  },
  watch: {
    active (nv) {
      this.$el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
    }
  }
}
</script>

<style scoped lang="scss">
.mrow {
  cursor: pointer;
  position: relative;
}
.mrow:hover {
  background: var(--v-backgroundHover-base);
}
.disabled {
  opacity: 0.2;

  &.mrow {
    cursor: default!important;
  }
  &.mrow:hover {
    box-shadow: none!important;
  }
}
::v-deep .highlight-class {
  font-weight: bold;
  background: none;
  position: relative;
  color: currentColor;
  

  &::before {
    background-color: currentColor;
    bottom: 0;
    content: "";
    left: 0;
    opacity: 0.22;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: 0.3s 
    }
}
</style>
